import React from "react"
import { Navigate, useParams } from "react-router-dom"

import { RoutesPaths } from "../../../../constants/routes.ts"
import NotFoundPage from "../../../NotFoundPage"

export function LegacyProjectTemplateRedirect() {
  const { id } = useParams<{ id: string }>()

  // Legacy project-template URLs used a numeric id (/settings/templates/42).
  // Any other sub-path (e.g. a deferred type like /settings/templates/budget)
  // is unknown — show a 404 rather than redirect into a broken detail page.
  if (!id || !/^\d+$/.test(id)) return <NotFoundPage />

  return <Navigate replace to={RoutesPaths.settings.projectTemplate(id)} />
}
